import { useDispatch, useSelector } from "react-redux";

import {
  DateComponent,
  Input,
  VerifyInput,
  TextArea,
  RadioInput,
  DropdownV1,
  Label,
  Upload,
  Checkbox,
  ButtonV1,
  EmailComponent,
  InputGroup,
  InputSuggestion,
  SubHeader,
  RadioQuestion,
  OTP,
  RadioCheckbox,
  Toggle,
  Number,
  CheckBoxQuestion,
  Mobile,
  ViewCard,
  ActionCard,
  DobComponent,
  Note,
  DocumentViewer,
  CustomTab,
  NavPanel,
  UserDetail,
  Agreement,
  PopoverComponent,
  

 Scorefield,
  MultiDropdown,
  RecursiveViewCard,
  Declarations,
  DocumentsMapper,
  MultipleFileUpload,
  Vkyc,
  Break,
  Telephone,
  PageHeader,
  RadioTemplate,
  Location,
  Icon,
  Liveness,
  LivenessDetection,
  Capture,
  VerificationGroup,
  VideoViewer,
  PaymentAmountInput,
  PaymentNote,
  csvUpload,
  HiddenField,
  InputTags,
  QuizModule,
  CustomDropdown,
  MultiSelectCheckbox,
  MultiSelectDropdown,
  SingleSelectDropdown,
  DynamicButton,
  ZipUpload,
  SearchableDropdown
} from "lib";

import { verifyOtp } from "api/otpVerification";
import CommentTextArea from "components/Comment";
import "./index.scss";
import {
  setQuestionData,
  setQuestionnaireId,
  setSelectedQuestion,
  setUpdateQuestionData,
} from "redux/formDisplay";
import Activity from "components/Activity";
import NavTabs from "lib/NavTabs";
import ViewBlockCard from "lib/ViewBlockCard";
import CommonTabs from "lib/CommonTabs";
import { useCallback } from "react";
import { setEditSaveData } from "redux/fieldRecursiveReducer";
import { setShowRecursiveForm } from "redux/recursiveReducer";
import CardQueue from "lib/CardQueue";
import { useState ,useEffect,useMemo } from "react";
import RecursiveDataPreview from "components/RecursiveDataPreview";
import RecursiveUpload from "lib/RecursiveUpload";
import PopoverDropdown from "lib/PopoverDropdown";
import HtmlToTags from "lib/HtmlToTags";
import Currency from "lib/Currency";
import { generateCurrency } from "helper/calculateNetAsset";
import CustomDatePicker from "lib/DatePicker";
import PaymentTransactionPreview from "components/PaymentTransactionPreview";
import PaymentCommonTabs from "lib/PaymentCommonTabs";
import RecursiveViewBlock from "lib/RecursiveViewBlock";
import FieldComparison from "lib/FieldComparison";
import ResponsiveDropdown from "lib/ResponsiveDropdown";
import RecursiveGroupApprovalRemarks from "lib/RecursiveGroupApprovalRemarks";
import GroupApprovalViewCard from "lib/GroupApprovalViewCard";
import MultiInputComponent from "lib/MultiInput";

const DynamicForm = (props) => {
  const requestedDocs = useSelector(
    (state) => state?.requestedDocReducer?.requestedDocs
  );
  const is_view_mode = useSelector(
    (state) => state?.requestedDocReducer?.is_view_mode
  );
  const active_step = useSelector((state) => state?.userInfo?.userDetail?.active_step)
  const config = useSelector(( state) => state.configurationReducer?.config);
  const module_name = config?.wf_journey?.find(item => item?.step === active_step)?.module_name;
  const {
    formFields,
    setSelectedData = () => {},
    selectedData = {},
    formErr,
    setFormErr,
    clearFieldError,
    questionnaireId = "",
    switchingProfile = () => {},
    primaryUser,
    activeTab,
    setActiveTab,
    triggerItem,
    handleItemClick,
    tabIndex,
    isMapper,
    documentData,
    form_field_items,
    allData,
    isUserInitiated,
    isRecursive,
    recursive_section,
    recursive_Data,
    customStyle,
    applicantData,
    setShowPopover,
  } = props;
  
  const verificationResponses = useSelector((state) => state.uploadDocumentReducer);
  const userInfo = useSelector((state) => state.userInfo);
  const popupReducer = useSelector((state) => state?.popupReducer)
  const paymentInfo = useSelector((state) => state.paymentReducer);

  const IndirectEval = (evalString) => {
    return eval(evalString);
  };
  const tokenId = useSelector((state) => state.otpReducer.tokenId);
  const otpReducer = useSelector((state) => state.otpReducer)
  const selectedQuestion = useSelector(
    (state) => state.formData?.selectedQuestion
  );
  const questionData = useSelector((state) => state.formData?.questionData);
  //! Being used in eval Do Not Remove
  const search = window.location.search;
  const query = new URLSearchParams(search);
  const updateCustomBtn = useMemo(() => {
    return query.get("updateCustomBtn");
  }, [search,query])
  const applicantUser = useSelector((state) => state.userInfo?.applicantUser);
  const formData = useSelector((state) => state?.formData);
  const workflowUser = useSelector((state) => state.userInfo?.workflowUser);
  const recursive = useSelector((state) => state?.recursive);
  const guardianRecursive = useSelector((state) => state?.guardianRecursive);
  const restricted_view = useSelector((state) => state.formData?.restricted_view);
  const applicant = useSelector((state) => state?.userInfo?.primaryUser);
  const arrayName = useSelector((state) => state?.recursive?.arrayName);
  const loggedInUserInfo = useSelector((state) => state.loggedInUserInfo?.userAuthInfo);
  let loggedUserId = loggedInUserInfo?.profileInfo?.userId || null;
  let created_by = useSelector(state => state.userInfo?.primaryUser?.created_by);
  const disablePartial = useSelector(
    (state) => state?.paymentReducer?.payment_details?.disable_partial
  );
  const dispatch = useDispatch();
  const handleChange = (e) => {
    const { name, value } = e.target;
    clearFieldError && clearFieldError(name);
    //trim whitespace
    if(value == " "){
      value = value.trim()
     }
    dispatch(setSelectedData({ key: name, value: value }));
  };

  const doesAnySubWorkflowHasVkyc = useSelector(state => state?.vkycReducer?.doesAnySubWorkflowHasVkyc);
  const handleDefaultValue = (name, value) => {
    clearFieldError && clearFieldError(name);
    dispatch(setSelectedData({ key: name, value: value }));
  };
  const handleEmailChange = (e) => {
    const { name, value } = e.target;
    clearFieldError(name);
    // if (value === '' || re.test(value)) {
    dispatch(setSelectedData({ key: name, value: value }));
    // }
  };

  // const handleInputGroupChange = (e, req_type, requiredCheck) => {
  const handleInputGroupChange = (id, value) => {
    // dispatch(setSelectedData({ name: e.target.name , type: req_type, label: e.target.value, is_required: requiredCheck }))
    const re = /^(?!\s)[a-zA-Z0-9_\s-]*$/;
    if (value?.text === "" || re.test(value?.text)) {
    dispatch(
      setSelectedData({
        key: "value",
        value: { text: value.text, is_required: value.is_required },
      })
    );
    }
    // dispatch(
    //     setSelectedData({key : id , value : textValue })
    //   );
    // dispatch(setEditSaveData());
  };
  const handleInputGroupCheckboxChange = (e, textValue, req_type) => {
    dispatch(
      setSelectedData({
        name: e.target.name,
        type: req_type,
        label: textValue,
        is_required: e.target.checked,
      })
    );
  };

  const handleDateChange = (date, name) => {
    clearFieldError(name);
    dispatch(setSelectedData({ key: name, value: date }));
  };

  const handleDobChange = (majority, name, date, age) => {
    clearFieldError(name);
    dispatch(setSelectedData({ key: name, value: date }));
    dispatch(setSelectedData({ key: "majority", value: majority }));
    dispatch(setSelectedData({ key: "age", value: age }));
  };
  const currentUserRole =
  loggedInUserInfo?.modules?.find(
    (module) => module?.module_name === "low_code_dashboard"
    ) || {};

  const handleChangeNumber = (e) => {
    const re = /^[0-9\b]+(\.[0-9]{0,2})?$/;
    const { name, value } = e.target;
    clearFieldError(name);
    if (value === "" || re.test(value)) {
      dispatch(setSelectedData({ key: name, value: value }));
    }
  };

  const handleCurrencyChange = (name,value) => {
    clearFieldError(name);
    dispatch(setSelectedData({ key: name, value: value }));
  }

  const handleRadioChange = (e) => {
    const { name, value } = e.target;
    clearFieldError(name);
    dispatch(setSelectedData({ key: name, value: value }));
  };
  const handleRadioTemplateChange = (e, description) => {
    const { name, value} = e.target;
    clearFieldError(name);
        dispatch(setSelectedData({ key: name, value: value }));
        dispatch(setSelectedData({ key: name+"_description", value: description }))
  };

  const handleDropdown = (e) => {
    const { name, value } = e.target;
    clearFieldError(name);
    // if (value !== "Select") {
      dispatch(setSelectedData({ key: name, value: value }));
    // }
  };

  const handleSearchDropdown = (e) => {
    const { name, value } = e.target;
    clearFieldError(name);
      dispatch(setSelectedData({ key: name, value: value }));
  };

  
  const handleCustomDropdown = (e) => {
      const { name, value } = e.target;
      clearFieldError(name);
      dispatch(setSelectedData({ key: name , value: value }));
      let customObj = e.target.options[e.target.selectedIndex]?.getAttribute('customValue');
      if(customObj){
        let res = JSON.parse(customObj)
        if(typeof(res)== "object"){
            for (const [field,data ] of Object.entries(res)) {
              dispatch(setSelectedData({ key: name + "_" + field, value: data }));
            }
          }
          else{
            let data = customObj?.replace(/"/g,'');
           dispatch(setSelectedData({ key: name + "_custom_field", value: data }));
          }
        }
    };
  
     
  


  const handleCheckBoxChange = (name, value) => {
    clearFieldError(name);
    dispatch(setSelectedData({ key: name, value: value }));
  };
  const handleRadioQuestionChange = (
    e,
    label,
    question,
    id,
    questionnaireId,
    content,
    optionId
  ) => {
    const { name, value } = e.target;
    clearFieldError(name);
    let obj = {};
    // 
    // console.log(content);

    obj.question_id = id;
    obj.question = question;
    obj.answer = label;
    obj.content = content;
    obj[id] = optionId;
    let quesobj = questionData.find((item) => item?.question_id == id);
    if (quesobj?.question_id == id) {
      let copyQuestionData = JSON.parse(JSON.stringify(questionData));
      let Index = copyQuestionData.findIndex((obj) => obj?.question_id == id);
      copyQuestionData[Index].question_id = id;
      copyQuestionData[Index].question = question;
      copyQuestionData[Index].answer = label;
      copyQuestionData[Index].content = content;
      copyQuestionData[Index].optionId = optionId;
      dispatch(setUpdateQuestionData(copyQuestionData));
    } else {
      dispatch(setQuestionData(obj));
    }
    dispatch(setSelectedData({ key: name, value: question }));
    dispatch(setSelectedQuestion({ key: name, value: value }));
    dispatch(setQuestionnaireId(questionnaireId));
  };
  

  const handleRadioCheckboxChange = (e) => {
    const { name, value } = e.target;
    clearFieldError(name);
    dispatch(setSelectedData({ key: name, value: value }));
  };

  const handleToggleChange = (name, value) => {
    clearFieldError(name);
    if (name == arrayName) {
      dispatch(setShowRecursiveForm(value))
    }
    dispatch(setSelectedData({ key: name, value: value }));
  };

  const handleMobileChange = (name, value) => {
    clearFieldError(name);
    dispatch(setSelectedData({ key: name, value: value }));
  };
  const handleTelephoneChange = (name, value) => {
    clearFieldError(name);
    dispatch(setSelectedData({ key: name, value: value }));
  };

  const handleOTPChange = (name, value, otp_retries_limit , otp_blocking_time) => {
    let payload = {
      otp: value,
      token_id: tokenId[name],
      key: name,
      name: applicantUser?.first_name,
      application_ref_id: primaryUser?.application_ref_id,
      maximum_retry : otp_retries_limit,
      blocking_duration : otp_blocking_time
    };
    // console.log(payload);
    dispatch(verifyOtp(payload));
    dispatch(setSelectedData({ key: name, value: value }));
  };

  const handleMultiDropdown = (name, value) => {
    clearFieldError(name);
    dispatch(setSelectedData({ key: name, value: value }));
  };

  const handleMultiOptionsChange = (
    id,
    label,
    question,
    checked,
    score,
    questionnaireId,
    name,
    content,
    optionId
  ) => {
    clearFieldError(name);
    const copyQuestionData = JSON.parse(JSON.stringify(questionData));
    const index = copyQuestionData.findIndex(
      (item) => item?.question_id === id
    );
    if (index !== -1) {
      if (checked) {
        if (!copyQuestionData[index].answer) {
          copyQuestionData[index].answer = [];
        }
        if (!copyQuestionData[index].answer.includes(label)) {
          copyQuestionData[index].answer.push(label);
        }
      } else {
        copyQuestionData[index].answer = copyQuestionData[index].answer.filter(
          (answer) => answer !== label
        );
      }
      copyQuestionData[index] = {
        ...copyQuestionData[index],
        question_id: id,
        question: question,
        content: content,
        answer: copyQuestionData[index].answer,
      };
      dispatch(setUpdateQuestionData(copyQuestionData));
    } else {
      const newQuestionData = {
        question_id: id,
        question: question,
        content: content,
        answer: checked ? [label] : [],
      };
      dispatch(setQuestionData(newQuestionData));
    }
    dispatch(
      setSelectedQuestion({
        key: id,
        value: score,
      })
    );
    dispatch(setQuestionnaireId(questionnaireId));
  };
  const handleSingleOptionsChange = (
    label,
    question,
    id,
    questionnaireId,
    content,
    optionId,
    optionScore,
    name
  ) => {
    clearFieldError(name);
    let obj = {};
    obj.question_id = id;
    obj.question = question;
    obj.answer = label;
    obj.content = content;
    obj[id] = optionId;
    let quesobj = questionData.find((item) => item?.question_id == id);
    if (quesobj?.question_id == id) {
      let copyQuestionData = JSON.parse(JSON.stringify(questionData));
      let Index = copyQuestionData.findIndex((obj) => obj?.question_id == id);
      copyQuestionData[Index].question_id = id;
      copyQuestionData[Index].question = question;
      copyQuestionData[Index].answer = label;
      copyQuestionData[Index].content = content;
      copyQuestionData[Index].optionId = optionId;
      dispatch(setUpdateQuestionData(copyQuestionData));
    } else {
      dispatch(setQuestionData(obj));
    }
    dispatch(setSelectedData({ key: name, value: question }));
    dispatch(setSelectedQuestion({ key: name, value: optionScore }));
    dispatch(setQuestionnaireId(questionnaireId));
  };

  const getSelectedValue = (item) => {
    const { type, name } = item;
    if (type === "currency") {
      if(selectedData[name]){
        let currency = selectedData[name]?.split(",").join("")
        currency = generateCurrency(currency,item.currency_type)
        return currency
      }
    }
    if (type === "dropdown") {
      const selectedOption = item?.options?.find((_item) => {
        return _item.label === selectedData[name];
      });
      return selectedOption;
    }
    if (type === "searchableDropdown") {
      const selectedOption = item?.options?.find((_item) => {
        return _item.label === selectedData[name];
      });
      return selectedOption;
    }
    if (type === "radio") {
      const selectedOption = item?.options?.find((item) => {
        return item.label === selectedData[name];
      });
      return selectedOption;
    }
    if (type == "radioquestion") {
      const selectedOption = item?.options?.find((item) => {
        return item.score === selectedQuestion[name];
      });
      return selectedOption;
    }
    // if (type == "mobile") {
    //   const selectedValue = "";
    //   return selectedValue;
    // }
    if (type === "multidropdown") {
      const selectedOption = item?.options?.find((_item) => {
        return _item.label === selectedData[name];
      });
      return selectedOption;
    }
    if (type === "radioTemplate") {
      const selectedOption = item?.options?.find((_item) => {
        return _item.label === selectedData[name];
      });
      return selectedOption;
    }
    if (type === "inputGroup") {
      return selectedData.value;
    }
    if (type === "customDropdown") {
      const selectedOption = item?.options?.find((_item) => {
        return _item.label === selectedData[name];
      });
      return selectedOption;
    }
    return selectedData[name];
  };

  const checkFieldVisibility = (field) => {
    const dependent_field = field?.show;
    if (dependent_field) {
      return IndirectEval(dependent_field);
    }

    // Showing dependent field using field expression (To-Do:- The below code should be removed after checking the config)
    const dependent_field_expression = field?.dependent?.expression;
    if (dependent_field_expression && dependent_field_expression.length) {
      return IndirectEval(dependent_field_expression);
    }
    return true;
  };

  const renderFields = (data) => {
    if (!FieldMap?.[data?.type]) return null;
    const { component: Component, ...restProps } = FieldMap[data?.type];
    const finalProps = {
      ...restProps,
      ...data,
      ...data.error_messages,
    };

    return <Component {...finalProps} />;
  };

  const handleMultiInputEmailChange = (name, value) => {
    clearFieldError(name);
    dispatch(setSelectedData({ key: name, value: value }));
  };

  const FieldMap = {
    quizModule: {
      component: QuizModule,
      onChange: handleRadioQuestionChange,
    }, 
    text: {
      component: Input,
      selectedData: selectedData,
      onChange: handleChange,
      onLoad: handleDefaultValue,
      setSelectedData: setSelectedData,
    },
    paymentInput: {
      component: PaymentAmountInput,
      selectedData: selectedData,
      onChange: handleChange,
      onLoad: handleDefaultValue,
      setSelectedData: setSelectedData,
      setFormErr,
      formErr,
    },

    numberExtractionInput: {
      component: VerifyInput,
      selectedData: selectedData,
      onChange: handleChange,
      onLoad: handleDefaultValue,
      setSelectedData: setSelectedData,
    },
    inputGroup: {
      component: InputGroup,
      onChange: handleInputGroupChange,
      onCheckBoxChange: handleInputGroupCheckboxChange,
    },
    number: {
      component: Number,
      onChange: handleChangeNumber,
      onLoad: handleDefaultValue,
      selectedData: selectedData,
    },
    currency: {
      component: Currency,
      onChange: handleCurrencyChange,
      selectedData: selectedData,
      formErr,
      setFormErr,
      clearFieldError,
    },
    email: {
      component: EmailComponent,
      onChange: handleEmailChange,
    },
    date: {
      component: DateComponent,
      onChange: handleDateChange,
      selectedData: selectedData,
      onLoad: handleDefaultValue,
    },
    datepicker: {
      component: CustomDatePicker,
      onChange: handleDateChange,
      selectedData: selectedData,
    },
    radio: {
      component: RadioInput,
      onChange: handleRadioChange,
      workflowUser : workflowUser
    },
    radioTemplate: {
      component: RadioTemplate,
      onChange: handleRadioTemplateChange,
    },
    dropdown: {
      component: DropdownV1,
      onChange: handleDropdown,
      setSelectedData: setSelectedData,
      selectedData: selectedData,
    },
    searchableDropdown: {
      component: SearchableDropdown,
      onChange: handleSearchDropdown,
      setSelectedData: setSelectedData,
      selectedData: selectedData,
      clearFieldError
    },
    customDropdown: {
      component: CustomDropdown,
      onChange: handleCustomDropdown,
      setSelectedData: setSelectedData,
      selectedData: selectedData,
      clearFieldError,
      formErr,
      setFormErr
    },
    textarea: {
      component: TextArea,
      onChange: handleChange,
      selectedData: selectedData,
      onLoad: handleDefaultValue
    },
    location: {
      component: Location,
      onChange: handleChange,
      onLoad: handleDefaultValue,
      setSelectedData: setSelectedData,
      selectedData: selectedData,
    },
    subheader: {
      component: SubHeader,
    },
    upload: {
      component: Upload,
      clearFieldError,
      selectedData,
      setSelectedData,
      formErr,
       setFormErr,
       isRecursive
    },
    label: {
      component: Label,
    },
    checkbox: {
      component: Checkbox,
      onChange: handleCheckBoxChange,
    },
    otp: {
      component: OTP,
      onChange: handleOTPChange,
    },
    field_comparison: {
      component: FieldComparison,
      selectedData:selectedData
    },
    radioquestion: {
      component: RadioQuestion,
      onChange: handleRadioQuestionChange,
      riskProfile: restricted_view,
    },
    checkboxquesiton: {
      component: CheckBoxQuestion,
      onChange: handleCheckBoxChange,
    },
    radiocheckbox: {
      component: RadioCheckbox,
      onChange: handleRadioCheckboxChange,
    },
    toggle: {
      component: Toggle,
      onChange: handleToggleChange,
      setSelectedData: setSelectedData,
      selectedData: selectedData,
      formErr,
      setFormErr,
      clearFieldError,
    },
    mobile: {
      component: Mobile,
      onChange: handleMobileChange,
      selectedData: selectedData,
      formErr,
      setFormErr,
      clearFieldError,
    },
    telephone: {
      component: Telephone,
      onChange: handleTelephoneChange,
      selectedData: selectedData,
      formErr,
      setFormErr,
      clearFieldError,
    },
    view_card: {
      component: ViewCard,
      selectedData: selectedData,
      primaryUser: primaryUser,
      input_fields: formFields?.input_fields,
      setSelectedData: setSelectedData,
      formErr,
      setFormErr,
      clearFieldError
    },
    group_approval_view_card: {
      component: GroupApprovalViewCard,
      selectedData: selectedData,
      primaryUser: primaryUser,
      input_fields: formFields?.input_fields,
      form_field_items: formFields,
    },
    action_card: {
      component: ActionCard,
      onClick: switchingProfile,
    },
    dob: {
      component: DobComponent,
      onChange: handleDobChange,
      selectedData: selectedData,
    },
    note: {
      component: Note,
    },
    paymentNote: {
      component: PaymentNote,
      custom_styles: formFields?.custom_styles,
      selectedData: selectedData,
    },
    break: {
      component: Break,
    },
    icon:{
      component :Icon
    },
    pageheader: {
      component: PageHeader,
    },
    document_viewer: {
      component: DocumentViewer,
      selectedData: selectedData,
      isMapper,
      documentData,
      form_field_items,
      recursive_section,
      recursive_Data
    },
    custom_tab: {
      component: CustomTab,
      activeTab: activeTab,
      setActiveTab: setActiveTab,
    },
    nav_panel: {
      component: NavPanel,
      selectedData: selectedData,
    },
    comment_textarea: {
      component: CommentTextArea,
      formFields: formFields,
    },
    user_detail: {
      component: UserDetail,
      selectedData: selectedData,
      formFields: formFields,
    },
    activity: {
      component: Activity,
    },
    agreement: {
      component: Agreement,
      selectedData: selectedData,
      setSelectedData: setSelectedData,
      formErr,
      setFormErr,
      clearFieldError
    },
    nav_tabs: {
      component: NavTabs,
      selectedData: selectedData,
      form_groups: formFields?.fields,
      activeTab: activeTab,
      setActiveTab: setActiveTab,
    },
    view_block_card: {
      component: ViewBlockCard,
      selectedData: selectedData,
      form_item: formFields,
      index: tabIndex,
      setSelectedData : setSelectedData
    },
    recursive_view_block_card: {
      component: RecursiveViewBlock,
      selectedData: selectedData,
      form_item: formFields,
      tabIndex: tabIndex,
    },
    recursive_group_approval_view_block_card: {
      component: RecursiveGroupApprovalRemarks,
      selectedData: selectedData,
      form_item: formFields,
      tabIndex: tabIndex,
    },
    common_tabs: {
      component: CommonTabs,
      selectedData: selectedData,
      form_elements: formFields?.form_elements,
      formFields: formFields,
    },
    payment_common_tabs: {
      component: PaymentCommonTabs,
      selectedData: selectedData,
      form_elements: formFields?.form_elements,
      formFields: formFields,
    },
    button: {
      component: ButtonV1,
      formFields: formFields,
      label: formFields?.label,
      onClick: props?.handleButtonClick,
    },
    popover: {
      component: PopoverComponent,
      selectedData: selectedData,
      children: formFields?.list_items,
      triggerWhen: formFields?.trigger_when,
      trigger: triggerItem,
      handleItemClick: handleItemClick,
    },
    scorefield: {
      component:  Scorefield,
      selectedData: selectedData,
      input_fields:formFields?.input_fields,
    },

    popover_dropdown: {
      component: PopoverDropdown,
      selectedData: selectedData,
      children: formFields?.list_items,
      trigger: triggerItem,
      handleItemClick: handleItemClick,
      ...props
    },
    multidropdown: {
      component: MultiDropdown,
      onChange: handleMultiDropdown,
      setSelectedData: setSelectedData,
      selectedData: selectedData,
    },
    recursiveViewCard: {
      component: RecursiveViewCard,
      selectedData: selectedData,
      input_fields: formFields?.input_fields,
    },
    documentsMapper: {
      component: DocumentsMapper,
      selectedData: selectedData,
      input_fields: formFields?.input_fields,
    },
    declarations: {
      component: Declarations,
      selectedData,
      isMapper,
      documentData,
    },
    multipleFileUpload: {
      component: MultipleFileUpload,
      clearFieldError,
      selectedData,
      setSelectedData,
    },
    card_queue:{
      component: CardQueue,
      selectedData,
      allData,
      doesAnySubWorkflowHasVkyc
    },
    vkyc: {
      component: Vkyc,
      selectedData,
    },
    recursive_upload:{
      component: RecursiveUpload,
      selectedData,
    },
    html_to_tags: {
      component: HtmlToTags,
      selectedData
    },
    liveness : {
      component: Liveness,
      onChange: handleChange,
      onLoad: handleDefaultValue,
      setSelectedData: setSelectedData,
      selectedData: selectedData,
    },
   
    liveness_detection:{
      component: LivenessDetection,
      selectedData: selectedData,
      isMapper,
      documentData,
      form_field_items,
      recursive_section,
      recursive_Data
    },
    capture: {
      component: Capture,
      clearFieldError,
      selectedData,
      setSelectedData,
      formErr,
       setFormErr,
       isRecursive
    },
    verification_group : {
      component: VerificationGroup,
      selectedData: selectedData,
      setSelectedData: setSelectedData,
    },
    autoComplete: {
      component: InputSuggestion,
      onChange: handleChange,
      selectedData: selectedData,
      setSelectedData: setSelectedData,
      formErr,
      setFormErr,
      clearFieldError
    },
    video_viewer: {
      component: VideoViewer,
      selectedData: selectedData,
      isMapper,
      documentData,
      form_field_items,
      recursive_section,
      recursive_Data
      
    },
    csvupload: {
      component: csvUpload,
      clearFieldError,
      selectedData,
      setSelectedData,
      formErr,
      setFormErr,
      isRecursive
    },
    payment_transactions:{
      component: PaymentTransactionPreview,
      selectedData
    },
    hidden_field: {
      component: HiddenField,
      selectedData: selectedData,
      setSelectedData: setSelectedData
    },
    responsive_dropdown: {
      component: ResponsiveDropdown,
      setSelectedData: setSelectedData,
      selectedData: selectedData
    },
    input_tags: {
      component: InputTags,
      selectedData: selectedData,
      onLoad: handleDefaultValue,
      setSelectedData: setSelectedData,
      
    },
    multiselect_checkbox: {
      component: MultiSelectCheckbox,
      onChange: handleMultiOptionsChange,
      riskProfile: restricted_view,
    },
    multiselect_dropdown: {
      component: MultiSelectDropdown,
      onChange: handleMultiOptionsChange,
      riskProfile: restricted_view,
    },
    singleselect_dropdown: {
      component: SingleSelectDropdown,
      onChange: handleSingleOptionsChange,
      riskProfile: restricted_view,
    },
    dynamic_button: {
      component: DynamicButton,
      applicantData:applicantData,
      setShowPopover: setShowPopover,
      handleItemClick: handleItemClick,
      setSelectedData: setSelectedData,
    },
    multi_input: {
      component: MultiInputComponent,
      onChange: handleMultiInputEmailChange,
    },
    zipUpload: {
      component: ZipUpload,
    },
    
  };
  const [isMobile, setIsMobile] = useState(false);
  const checkWindowWidth = () => {
    const width = window.innerWidth;
    if (width < 640 && !isMobile) {
      // console.log("false", width);
      setIsMobile(true);
    } else if (width > 640 && isMobile) {
      setIsMobile(false);
    }
  };
  window.addEventListener("resize", () => checkWindowWidth());
  useEffect(() => {
    checkWindowWidth()
  }, [])

  const isEditFlow = () => (requestedDocs?.requestedFlow === "edit") || (active_step > 2 && module_name === "Dynamic Forms");
  const isUpdateFlow = () => requestedDocs?.requestedFlow === "update" || requestedDocs?.requestedFlow === "updateSection";
  const isUserLoggedIn = () => !!loggedUserId;
  const isUserInitiatedFlow = () => !!isUserInitiated;

  const isDocumentRequested = (field) => {
    const requestedDocuments = requestedDocs?.updateRequestedFields;
    const dependentFields = requestedDocs?.dependentFields;
    if(requestedDocuments || dependentFields){
    const isFieldInObj =
      requestedDocuments?.length > 0 &&
      requestedDocuments?.some(
        (item) => item.name === field.name || item.name === field.id
      );
    const isDependentField =
      dependentFields?.length > 0 &&
      dependentFields?.some(
        (item) => item.name === field.name || item.name === field.id
      );
    return isFieldInObj || isDependentField;
      }else{
        return true
      }
  };

  const isFieldEditable = (field) => {
    if (is_view_mode) return false;
    if (isUpdateFlow()) {
      return isDocumentRequested(field);
    } else if (isUserLoggedIn() || isUserInitiatedFlow()) {
      return true;
    } else if (created_by && !isUserLoggedIn()) {
      return false;
    } else if (active_step > 1) {
      return isEditFlow();
    } else {
      return true;
    }
  };

  const chooseRenderMethod = (field) => {
    const value = getSelectedValue(field);
    const isRenderAllowed = checkFieldVisibility(field);
    const error = formErr?.[field.name]?.err || "";
    const isEditable = isFieldEditable(field);

    return (
      isRenderAllowed &&
      renderFields({
        ...field,
        value,
        error,
        questionnaireId,
        isEditable,
        isURLForUpdateByRM: isUpdateFlow(),
        name: field?.name,
        isMobile,
      })
    );
  };



  return <>{chooseRenderMethod(formFields)}</>;
};

export default DynamicForm;
